import { HonorariumWorkflow } from './HonorariumWorkflow';

/**
 * HonorariumManagement Component
 * 
 * This component has been updated to use the new three-step workflow:
 * 1. PnC Review - Review attendance and approve for BU
 * 2. BU Review - Update donor details and approve for Finance 
 * 3. Finance Review - Download and process payments
 * 
 * The component now uses role-based access control and section-specific endpoints.
 */
export const HonorariumManagement = () => {
  return <HonorariumWorkflow />;
};